var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAureaSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.9759129px",
    height: "43.451902px",
    viewBox: "0 0 31.9759129 43.451902",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MERCADO-SECUND\\xC1RIO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-18, -18.0003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(18, 18.0003)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCAA5A",
    points: "0 43.4517587 10.6671078 43.4517587 15.9755856 30.5182547 10.6417929 17.5623018"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1E1E1C",
    points: "21.3088051 17.5619674 15.9754901 30.5179204 21.3083275 43.451902 31.9759129 43.451902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#AC793D",
    points: "10.6419362 17.5619674 15.9752513 30.5179204 21.3085663 17.5619674"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#DCAA5A",
    points: "17.7951029 0 23.128418 12.955953 28.4622107 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#AC793D",
    points: "21.3088051 17.5842731 15.9754901 4.62832016 10.642175 17.5842731"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureaSlogo);
export default __webpack_public_path__ + "static/media/AUREA_slogo.ac1708f0e999f814a53e4563158cda74.svg";
export { ForwardRef as ReactComponent };